const isEqual = (x, y) => {
  if (x === y) {
    return true;
  } else if (typeof x == 'object' && x != null && typeof y == 'object' && y != null) {
    if (Object.keys(x).length !== Object.keys(y).length) return false;

    for (var prop in x) {
      if (y.hasOwnProperty(prop)) {
        if (!isEqual(x[prop], y[prop])) return false;
      } else return false;
    }

    return true;
  } else return false;
};

const isEmpty = (x) => {
  if (x === null || x === undefined) return true;
  if (typeof x === 'object') {
    return Object.keys(x).length === 0;
  }
  if (Array.isArray(x) || typeof x === 'string') {
    return x.length === 0;
  }

  return true;
};

const camelCase = (x) => {
  return x
    .replace(/[^a-zA-Z0-9]+/g, ' ') // Replace non-alphanumeric characters with space
    .trim() // Trim spaces from start and end
    .split(' ') // Split into words
    .map((word, index) =>
      index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(''); // Join words without spaces
};

export { isEqual, isEmpty, camelCase };
